import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';

import { ConnatixPlayer } from './ConnatixPlayer/ConnatixPlayer';
import { ExcoPlayer } from './ExcoPlayer/ExcoPlayer';

enum VideoPlayerType {
  Exco = 'ExcoPlayer',
  Connatix = 'ConnatixPlayer',
}

//Kansas State - No videos in playlist

const excoSites = [
  47, 81, 39, 363, 79, 60, 49, 377, 372, 14, 83, 13, 80, 31, 373, 55, 365, 248,
  29, 371, 370, 36,
];

export const VideoPlayer = () => {
  const { currentSite } = useSite();
  let selectedPlayer: VideoPlayerType = VideoPlayerType.Connatix;

  if (excoSites.includes(currentSite.key)) {
    selectedPlayer = VideoPlayerType.Exco;
  }

  return (
    <>
      {selectedPlayer === VideoPlayerType.Exco && <ExcoPlayer />}
      {selectedPlayer === VideoPlayerType.Connatix && <ConnatixPlayer />}
    </>
  );
};
